'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { Navbar } from '@/components/Navbar'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <main className="min-h-screen bg-[#F7F1E7]">
      <div className="container">
        {/* Sticky header with top border and navbar */}
        <div className="sticky top-0 z-50">
          <div className="separator-line" />
          <Navbar />
        </div>

        {/* Error Content */}
        <section className="px-[24px] py-[60px] min-h-[400px] flex flex-col items-center justify-center text-center">
          <h1 className="text-[32px] font-bold mb-[16px]">Something went wrong</h1>
          <p className="text-xl mb-[32px]">
            We're sorry, but something unexpected happened.
          </p>

          <div className="flex flex-col gap-[16px] text-l">
            <button
              onClick={() => reset()}
              className="px-[24px] py-[12px] bg-[#1A1A1A] text-[#F7F1E7] rounded-[8px] font-bold"
            >
              Try again
            </button>
            <Link href="/" className="underline">
              Go to homepage
            </Link>
          </div>
        </section>

        {/* No footer here: the error page must stay dependency-free — the
            full Footer reads content from disk (fs) for its localized links,
            which both breaks the client bundle and could re-trigger the very
            error being shown. */}

        {/* Bottom separator */}
        <div className="separator-line" />
      </div>
    </main>
  )
}
